import type { FC } from "react";

import { useTextSeparatorWithDirectionalMark } from "@ui/hooks/useTextSeparatorWithDirectionalMark";

import type { Address } from "@jti/fe-common";

type AddressStreetInfoJordanVariantProps = Partial<Address>;

export const AddressStreetInfoJordanVariant: FC<AddressStreetInfoJordanVariantProps> = ({
  city,
  streetName,
  streetNumber,
  streetAdditional,
}) => {
  const { joinWithSeparator } = useTextSeparatorWithDirectionalMark();

  const streetinfo = joinWithSeparator(streetName, streetNumber);

  return (
    <>
      <div data-testid="addressInfoStreetJordan">{streetinfo}</div>
      {streetAdditional && <div data-testid="addressInfoAdditionalJordan">{streetAdditional}</div>}
      <div data-testid="addressInfoCityJordan">{city}</div>
    </>
  );
};
